import React from "react";
import classnames from "classnames";
import { FormattedMessage } from "react-intl";

import "./style.scss";

interface IProps {
  children: any;
  kind?: string;
  icon?: JSX.Element;
  className?: string;
  fullWidth?: boolean;
  isLoading?: boolean;
  [key: string]: any;
}

const Button = ({
  children,
  kind = "default",
  icon,
  className,
  fullWidth,
  isLoading = false,
  ...props
}: IProps) => (
  <button
    className={classnames("cnb-button", className, kind, {
      "full-width": fullWidth
    })}
    {...props}
  >
    {isLoading ? (
      <img className="loading-btn" src="/assets/images/loading.gif" />
    ) : (
      icon
    )}
    <FormattedMessage id={children} tagName="span" />
  </button>
);

export default Button;
